<!-- shopy Head -->
<div class="loader_session" *ngIf='loaderdata'>
    <div class="loader-4"><span></span>
    </div>
  </div>
  <div class="collecting-header" style="background-image: url(assets/image/Group-1895.png);">
    <div class="collecting-head">
      <div class="head">
        <h3>Library Categories</h3>
        <!-- <h1 class="select-category">Select Category</h1> -->
      </div>
    </div>
  </div>
  
  
  <!-- <h1 class="head">Choose the category</h1> -->
  <!-- <p>{{data.category}}<br><br><br><br><br><br></p> -->
  <!-- collections details -->
  <div class="container">
    <div class="collection-items">
      <div class="row">
        <ng-template ngFor let-item [ngForOf]="data">
      

          <div class="col-lg-4 col-md-6 collections" [routerLink]="['/categoryitem/',item.category]"  >
            <div class="collection-elements">
              <div class="coll-detials">
                <h2>{{item.category}}</h2>
              </div>
            </div>
          </div>
        </ng-template>

        <div class="col-lg-4 col-md-6 collections" >
          <div class="collection-elements">
            <div class="coll-detials">
              <h2 >
                <a style=" color: inherit ;text-decoration:none;" href="https://apsblobdeve.blob.core.windows.net/aps-website-files/APS Content Index.pdf"
            target="_blank">INDEX</a>
              </h2>
            </div>
          </div>
        </div>


  
      </div>
      <!-- pagination -->
      <div class="event-pagination">
        <div class="container">
          <div class="pagination-items">
            <div class="elements">
              <a [routerLink]="['/category/',1]" class="pag-btn">
                <i class="fa fa-angle-double-left" aria-hidden="true"></i>
              </a>
              <ng-template [ngIf]="previous">
                <a [routerLink]="['/category/',previous]" class="pag-btn">
                  <i class="fa fa-angle-left" aria-hidden="true"></i>
                </a>
              </ng-template>
              <span>
                <a class="pag-item-previous"> PREVIOUS</a>
                <a class="pag-item-next"> NEXT </a>
              </span>
              <ng-template [ngIf]="next">
                <a [routerLink]="['/category/',next]" class="pag-btn">
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </a>
              </ng-template>
              <a [routerLink]="['/category/',last]" class="pag-btn">
                <i class="fa fa-angle-double-right" aria-hidden="true"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <app-contactform></app-contactform>